import request from '@/utils/request'

// 投诉列表
export function lodgeList(data) {
  return request({
    url: `/sys/complaint/list`,
    method: 'post',
    data
  })
}

// 删除投诉
export function lodgeDelete(data) {
    return request({
        url: `/sys/complaint/delete`,
        method: 'post',
        data
    })
}

// 投诉详情
export function lodgeDetail(id) {
    return request({
        url: `/sys/complaint/info/${id}`,
        method: 'get'
    })
}

// 投诉新增
export function lodgeSave(data) {
    return request({
        url: `/sys/complaint/save`,
        method: 'post',
        data
    })
}

// 投诉编辑
export function lodgeUpdate(data) {
    return request({
        url: `/sys/complaint/update`,
        method: 'post',
        data
    })
}